import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { dateStringToHowLongAgo } from '../../../utils';
import UserProfileImage from '../UserProfileImage';
import './styles.scss';

const ResponseItem = ({ sellerResponse, sellerUsername, sellerImage }) => {

    const createdAt = dateStringToHowLongAgo(sellerResponse.get('created_at'));

    return (
        <div className="response-item">
            <UserProfileImage username={sellerUsername} userImage={sellerImage}/>

            <header>
                <h5>{i18n.t('reviews.users.show.seller_response')}</h5>
            </header>

            <p>{sellerResponse.get('comment')}</p>
            <time>{createdAt} {i18n.t('reviews.general.ago')}</time>
        </div>
    );
};


ResponseItem.propTypes = {
    sellerResponse: PropTypes.object.isRequired,
    sellerUsername: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
    sellerUsername: state.get('seller_username'),
    sellerImage: state.get('seller_img_url')
});

export default connect(mapStateToProps)(ResponseItem);



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/NewReviewItem/ResponseItem/index.js